<template lang="pug">
	.edit-campaign(v-if="showed")
		.card
			.card-header Edit Campaign
			.card-body
				.property
					.property-name Campaign Name
					.property-value
						input.form-control(v-model="campaignName" ref="campaignNameInput")
				.property
					.property-name Active
					.property-value
						input.form-control.checkbox(type="checkbox" v-model="orderActive" ref="orderActiveInput")
				.error-message {{errorMessage}}
			.card-footer
				button.btn.btn-cancel(@click="hide") Cancel
				button.btn.btn-confirm(type="submit" @click="editCampaign") Save

</template>

<script>

import Screen from "@/mixins/screen";
import {Server} from "@/services/Server";

export default {
	name: 'CampaignActionsEdit',
	mixins: [Screen],
	screen: {
		updateOn: [],
		events: {
			'Edit Campaign Completed': function (error = false) {
				if (!error) {
					this.hide();
					return;
				}
				this.errorMessage = error;
			},
			'Campaign Active Status Confirmation': function (confirm) {
				if (!confirm) this.orderActive = this.campaign.active;
			}
		}
	},
	watch: {
		orderActive(newVal) {
			if (!!newVal !== !!this.campaign.active) {
				Broadcast.call("Show ActiveStatusConfirmationPopup", [{
					campaign: this.campaign,
					newStatus: newVal,
					type: 'campaign'
				}]);
			}
		}
	},
	data() {

		this.Server = Server;

		return {
			campaignName: '',
			orderActive: true,
			errorMessage: ''
		}
	},
	methods: {
		collectData(action, campaign) {

			if (!campaign) {
				this.hide();
				return;
			}

			this.campaign = campaign;

			this.campaignName = campaign.name;
			this.orderActive = campaign.active;
			this.errorMessage = '';

		},
		editCampaign() {
			if (!this.campaignName) {
				this.errorMessage = 'Please provide valid order name';
				return;
			}
			Server.sendToSocket({
				EditCampaign: {
					id: this.campaign.id,
					name: this.campaignName,
					active: this.orderActive
				}
			});
		}

	}
}

</script>

<style lang="sass">

.edit-campaign
	position: absolute
	z-index: 2000
	top: 0
	left: 0
	bottom: 0
	right: 0
	display: flex
	justify-content: center
	align-items: center

	>.card
		width: 400px

		>.card-footer
			display: flex
			flex-direction: row
			justify-content: space-between

		>.card-body
			display: flex
			flex-direction: column
			gap: 0.5em

			>.error-message
				font-size: 95%
				color: red
			>.property
				display: flex
				flex-direction: row
				align-items: center
				gap: 15px

				>.property-name
					width: 160px

				>.property-value
					flex: 1

					>input
						height: 35px
					>input.checkbox
						width: 35px
						height: 35px




</style>
